import { Route } from 'vue-router'
import { RouterNextFunction } from '@/shared/interfaces/router-next-function'
import { Injector } from '@/config/dependency-injection'
import { MetaService } from '@/shared/services/meta-service'

export function routeSeoGuard(to: Route, from: Route, next: RouterNextFunction) {
  Injector.get(MetaService).removeMetaTags()
  next()
}
